import { USER_LOGIN } from './user/UserActionTypes';
import { createReducer } from 'utils';
export const RESET_REQUESTED_PATHNAME = 'RESET_REQUESTED_PATHNAME';

const PathnameReducer = createReducer<string, { type: 'RESET_REQUESTED_PATHNAME'; payload: any }>(window.location.pathname, {
   [RESET_REQUESTED_PATHNAME]: () => '/',
   [USER_LOGIN]: (state, action) => {
      if (state === '/') {
         return action.payload.admin ? '/waveforms' : '/profile';
      }
      return state;
   },
});

export default PathnameReducer;
